import React from 'react';
import { useParams } from "react-router-dom";
import { projects } from '../../data/alldata';

const Detailproject = () => {
  const { name } = useParams();

  const project = projects.find(
    p => p.name.toLowerCase() === decodeURIComponent(name).toLowerCase()
  );

  if (!project) {
    return <div className="text-center mt-20">Project not found</div>;
  }

  return (
    <div className="p-12 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold mb-6 text-center">
        {project.name}
      </h1>

      <img
        src={project.image}
        alt={project.name}
        className="rounded-xl mb-6 w-full shadow-md"
      />

      <p className="mb-6 text-gray-700 leading-relaxed">
        {project.description}
      </p>

      <div className="flex flex-wrap justify-center gap-3 mb-10">
        {project.tags.map((tag, idx) => (
          <span
            key={idx}
            className={`px-3 py-1 rounded-full text-sm font-semibold ${tag.color}`}
          >
            #{tag.name}
          </span>
        ))}
      </div>

      {/* Live Demo - centered & clean */}
      {project.link && (
        <div className="flex justify-center">
          <a
            href={project.link}
            target="_blank"
            rel="noopener noreferrer"
            className="px-6 py-3 rounded-lg
                       bg-gradient-to-r from-blue-500 to-purple-600
                       text-white font-semibold
                       shadow-md
                       hover:shadow-lg hover:scale-105
                       transition-all duration-300"
          >
            🚀 Explore Project
          </a>
        </div>
      )}
    </div>
  );
};

export default Detailproject;
